import React from 'react';

interface CenteredProps {
  children: React.ReactNode;
}

export default function Centered({ children }: Readonly<CenteredProps>) {
  return <div className="a-centered">{children}</div>;
}

